import React, { PureComponent } from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import onClickOutside from 'react-onclickoutside';
import SVG from 'react-inlinesvg';
import keypadIcon from '@lifesize/ux-assets/vectors/svgIcons/keypad.svg';
import roomSystemIcon from '@lifesize/ux-assets/vectors/svgIcons/room-system.svg';
import classes from 'components/InCall/CallFooter.module.scss';
import _get from 'lodash/get';

export class OtherOptions extends PureComponent {
  handleClickOutside(evt) {
    const evtPath = _get(evt, 'path');
    if (!evtPath) return;
    // if the #inCallKebabBtn was not in the element list (path) of the propagated click event, then an outside click has occurred
    if (this.props.kebabExpanded && !evtPath.find(elt => _get(elt, 'id') === 'inCallKebabBtn')) {
      this.props.onKebabClicked();
    }
  }

  render() {
    return (
      <div className={`${classes.kebab} ${this.props.kebabExpanded ? classes.kebabShown : ''}`}>
        <button
          onClick={this.props.toggleDialPad}
          data-testid="dial-pad-btn"
        >
          <SVG src={keypadIcon} data-testid="keypadIcon" />
          <FormattedMessage
            id="components.incall.controls.kebab.tooltip"
            defaultMessage="Dial Pad"
          />
        </button>
        {this.props.canControlFarEndCamera &&
          <button
            onClick={this.props.openCameraControls}
            data-testid="fecc-btn"
          >
            <SVG src={roomSystemIcon} data-testid="roomSystemIcon" />
            <FormattedMessage
              id="components.incall.controls.kebab.controls"
              defaultMessage="Far-end camera controls"
            />
          </button>
        }
      </div>
    );
  }
}

OtherOptions.propTypes = {
  kebabExpanded: PT.bool.isRequired,
  onKebabClicked: PT.func.isRequired,
  toggleDialPad: PT.func.isRequired,
  openCameraControls: PT.func,
  canControlFarEndCamera: PT.bool
};

export default injectIntl(onClickOutside(OtherOptions));
